import { render } from "./WiseLoginForm.vue?vue&type=template&id=21a8b50f&scoped=true"
import script from "./WiseLoginForm.vue?vue&type=script&lang=js"
export * from "./WiseLoginForm.vue?vue&type=script&lang=js"

import "./WiseLoginForm.vue?vue&type=style&index=0&id=21a8b50f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a8b50f"]])

export default __exports__